var app = angular.module('app', ['bootstrap.main', 'ui.mask']);
app.value('appId', 'EPRWEB');
window.NOGOOGLEMAPSLOL = true;  // Temp solution to kill google maps per project

// UI Services
require('./factories/addFlowCommander')(app);
require('./factories/content')(app);
require('./factories/coverageBuddy')(app);
require('./factories/employee')(app);
require('./factories/employerUtility')(app);
require('./factories/eprSummaryModals')(app);
require('./factories/invisibleFormService')(app);
require('./factories/options')(app);
require('./factories/paState')(app);
require('./factories/planAdmin')(app);
require('./factories/provider')(app);
require('./factories/schemaValidator')(app);
require('./factories/uncoveredDependentModal')(app);
require('./factories/validatePcpFactory')(app);
require('./resources/content/changePcpSuccess')(app);

//services
require('./services/eprsvc/fireBaseToken')(app);
require('./services/eprsvc/challengeDisplayInfo')(app);
require('./services/eprsvc/createOtp')(app);
require('./services/eprsvc/validateOtp')(app);
require('./services/clients')(app);
require('./services/eprsvc/reportCodesValidate')(app);
require('./services/eprsvc/additionalGroupInformation')(app);
require('./services/eprsvc/benefitBooklets')(app);
require('./services/eprsvc/cancelCoverage')(app);
require('./services/eprsvc/cancelReasonCodes')(app);
require('./services/eprsvc/cancelledClientEmail')(app);
require('./services/eprsvc/claimDetails')(app);
require('./services/eprsvc/claimDetailsSupplement')(bootstrap); // jshint ignore: line
require('./services/eprsvc/claimSummary')(app);
require('./services/eprsvc/claimSummarySupplement')(bootstrap); // jshint ignore: line
require('./services/eprsvc/clientInformation')(app);
require('./services/eprsvc/coverages')(app);
require('./services/eprsvc/clientSearch')(app);
require('./services/eprsvc/ebill')(app);
require('./services/eprsvc/employeesSearch')(app);
require('./services/eprsvc/employeesSummary')(app);
require('./services/eprsvc/enrollments')(app);
require('./services/eprsvc/enrollmentReports')(app);
require('./services/eprsvc/groupContracts')(app);
require('./services/eprsvc/groupInformation')(app);
require('./services/eprsvc/ibcSbcPdf')(app);
require('./services/eprsvc/idTheft')(app);
require('./services/eprsvc/idcardMembers')(app);
require('./services/eprsvc/memberCOBHistory')(app);
require('./services/eprsvc/memberPCPHistory')(app);
require('./services/eprsvc/memberPlanHistory')(app);
require('./services/eprsvc/memberReportCodeHistory')(app);
require('./services/eprsvc/orderIdCard')(app);
require('./services/eprsvc/planAdminInfo')(app);
require('./services/eprsvc/preventiveMedications')(app);
require('./services/eprsvc/saveSpendingAccountInformation')(app);
require('./services/eprsvc/spendingAccountInformation')(app);
require('./services/eprsvc/spendingAccountVendors')(app);
require('./services/eprsvc/subscriberSummary')(app);
require('./services/eprsvc/summaryOfBenefits')(app);
require('./services/eprsvc/validateSSN')(app);
require('./services/eprsvc/vendorSSO')(app);
require('./services/eprsvc/visionProvider')(app);
require('./services/eprsvc/emailGroupContracts')(app);
require('./services/eprsvc/reasonCodesEprsvc')(app);
require('./services/eprsvc/mcuClients')(app);
require('./services/rbsmbl/dependentsPCP')(app);
require('./services/rbsmbl/employerChangePassword')(app);
require('./services/rbsmbl/subscriberPCP')(app);
require('./services/rbsmbl/reasonCodes')(app);
require('./services/rbsmbl/validatePcp')(app);
require('./services/rbsmbl/svcChangePcp')(app);
require('./services/rbsmbl/getGroupName')(app);
require('./services/eprsvc/censusReport')(app);
require('./services/eprsvc/lifeEventRules')(app);
require('./services/eprsvc/alerts')(app);
require('./services/eprsvc/visionAndDental')(app);
require('./services/eprsvc/cmodDownload')(app);
require('./services/eprsvc/architecture')(app);


//Directives
require('./directives/assistEmployees/eprChangeProvider')(app);
require('./directives/assistEmployees/eprChangeProviders')(app);
require('./directives/claims/claimStatus')(app);
require('./directives/claims/claimsRefine')(app);
require('./directives/common/calendarButton')(app);
require('./directives/common/cardImgError')(app);
require('./directives/common/clientSearchValidator')(app);
require('./directives/common/dateParser')(app);
require('./directives/common/eprHexHeader')(app);
require('./directives/common/eprCardHeader')(app);
require('./directives/common/eprCollapsibleRow')(app);
require('./directives/common/eprSsnToggle')(app);
require('./directives/common/feedbackBar')(app);
require('./directives/common/filterBoxAndTableDisplay')(app);
require('./directives/common/formValidationGenerator')(app);
require('./directives/common/formCompleteWidget')(app);
require('./directives/common/showFullSsn')(app);
require('./directives/common/spaPlanCard')(app);
require('./directives/common/typeahead')(app);
require('./directives/common/waitCursor')(app);
require('./directives/common/eprHotKeys')(app);
require('./directives/demogs/demogs-validators')(app);
require('./directives/employee/dependentCheckboxValidation')(app);
require('./directives/employee/eprAct4')(app);
require('./directives/employee/eprDependent')(app);
require('./directives/employee/eprDependentReview')(app);
require('./directives/employee/eprEmployeeSynopsis')(app);
require('./directives/employee/eprInsurance')(app);
require('./directives/employee/eprMajorMedical')(app);
require('./directives/employee/eprMedicare')(app);
require('./directives/employee/eprMNLOA')(app);
require('./directives/employee/eprPlanCoverage')(app);
require('./directives/employee/eprPlanMore')(app);
require('./directives/employee/eprProvider')(app);
require('./directives/employee/eprProviders')(app);
require('./directives/employee/eprQualifyingEvent')(app);
require('./directives/employee/eprReportCodes')(app);
require('./directives/employee/eprSaveFooter')(app);
require('./directives/employee/eprSubscriberInfo')(app);
require('./directives/employee/eprSummary')(app);
require('./directives/employee/eprSummaryActions')(app);
require('./directives/employee/eprTobaccoStatus')(app);
require('./directives/employee/eprTobaccoStatuses')(app);
require('./directives/employee/findEmployee')(app);
require('./directives/employee/findEmployeeResults')(app);
require('./directives/home/eprResourceBlock')(app);
require('./directives/planAdmin/spinner')(app);
require('./directives/planAdmin/groupEntitlements')(app);
require('./directives/profile/employerProfileSummary')(app);
require('./directives/employee/ssnNoZeroValidation')(app);
require('./directives/employee/fieldMatch')(app);
require('./directives/employee/effectiveDateValidation')(app);
require('./directives/employee/mnloaValidation')(app);
require('./directives/employee/binValidation')(app);
require('./directives/employee/pcnValidation')(app);
require('./directives/employee/spouseAndDomesticPartnerValidation')(app);
require('./directives/employee/lifeEventValidation')(app);
require('./directives/employee/recentDocumentAlerts')(app);
require('./directives/employee/inputField')(app);
require('./directives/common/architectureDiagram')(app);
require('./directives/common/tableFormat')(app)

// Filters
require('./filters/capitalize')(app);
require('./filters/dateInput')(app);
require('./filters/phoneNumber')(app);
require('./filters/productName')(app);
require('./filters/relationship')(app);
require('./filters/eligibility')(app);
require('./filters/employmentStatus')(app);
require('./filters/specialStatus')(app);
require('./filters/stringToDate')(app);

//Constants
require("./resources/appSchemas")(app);
require("./resources/idTheftDisclaimer")(app);

// Routes
// jshint ignore: start
var routes = [];
routes = routes.concat((window.aemSiteData || []).reduce(function(acc, data) {
	var route = {
		state: data.path.join('.'),
		url: '/' + data.page.name,
		postPassword: true,
		views: {
			"resources": {
				controller: ["$scope", function ($scope) {
					window.bbb = $scope;
					$scope.sidebar.betterBreadcrumbs.splice(data.path.length - 2, 999, {
						title: ((data.path.length - 1 == 1) ? "" : "") + data.page.props["navTitle"] || "Missing Heading",
						state: data.path.join('.')
					});
				}]
			}
		}
	};
	if (data.page.children) {
		var template = '<p style="margin-bottom: 24px;">' + (data.page.props["jcr:description"] || "Missing Description") + '</p>';
		data.page.children.forEach(function(child) {
			if (child.props["externalURL"]) {
				if (child.props["newWindow"]) {
					template += "<a href=\"" + child.props["externalURL"] + "\" target=\"_blank\">" + child.props["navTitle"] + "</a>";
				}
				else {
					template += "<a href=\"" + child.props["externalURL"] + "\">" + child.props["navTitle"] + "</a>";
				}
			}
			else {
				template += "<a data-ui-sref=\"" + child.path.join('.') + "\">" + child.props["navTitle"] + "</a>";
			}
			template += "<p style=\"margin-bottom: 12px;\">" + child.props["jcr:description"] + "</p>";
		});
		route.views["resources"].template = '<section data-ui-view="resources" style="min-height: 400px;">' + template + '</section>';
	}
	else {
		route.views["resources"].templateUrl = data.path.join('/') + '.employerTemplate.html/pages/resources/aem';
	}
	if (data.path.join('.') !== "resources") {
		acc.push(route);  // Temp hack for resources route error
	}
	return acc;
}, [])); // jshint ignore: end

routes = routes.concat(require('./pages/clients')(app));
routes = routes.concat(require('./pages/assistEmployees/assistEmployees')(app));
routes = routes.concat(require('./pages/claims/claims-agreement')(app));
routes = routes.concat(require('./pages/clientAndGroup/client-info')(app));
routes = routes.concat(require('./pages/clientAndGroup/group-list')(app));
routes = routes.concat(require('./pages/employee/add/add')(app));
routes = routes.concat(require('./pages/employee/employee')(app));
routes = routes.concat(require('./pages/employee/find/find')(app));
routes = routes.concat(require('./pages/home/home')(app));
routes = routes.concat(require('./pages/home/cancelledConditions')(app));
routes = routes.concat(require('./pages/profile/profile')(app));
routes = routes.concat(require('./pages/verifyAndAgree/verifyAndAgree')(app));
routes = routes.concat(require('./pages/changePassword/changePassword')(app));
routes = routes.concat(require('./pages/reports/reports')(app));
routes = routes.concat(require('./pages/resources/resources')(app));
routes = routes.concat(require('./pages/reports/requestedReports')(app));
routes = routes.concat(require('./pages/reports/censusOrWellness')(app));
routes = routes.concat(require('./pages/architecture')(app));
routes = routes.concat(require('./pages/mcuClientSelection/mcuClientSelection')(app));

for (var i = 0; i < routes.length; i++) {
	var s = routes[i].url.split("?");
	s[0] = s[0] + "{url:(?:.html)?}";
	routes[i].url = s.join("?");
}

app.service('routes', function () { return routes; });

app.run(['navigation', '$rootScope', '$state', '$cookies', function(navigation, $rootScope, $state, $cookies) {
	navigation.setFilter('portal', function (item) {
		return "employer" == item.filterData.portal;
	});

	$rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState) {
		$state.previous = fromState;
		$state.next = toState;
	});
}]);

app.config(['$locationProvider', '$urlRouterProvider', function($locationProvider, $urlRouterProvider) {
	$urlRouterProvider.otherwise('/home');
	$locationProvider.html5Mode(true);
}]);
